export default "__VITE_PUBLIC_ASSET__fbf29fe2__"